/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { TicketContainer } from '../tickets/TicketContainer';
import { Texture } from 'pixi.js-legacy';
import { TicketComponentHelper } from './TicketComponentHelper';
import { TicketWorkDaysContainer } from './TicketWorkDaysContainer';
import { convertHexStringToNumber } from 'utils/color-utils';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { EventBinder } from '@appCanvasCommon/interaction/EventBinder';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';
import { CursorType } from '@appCanvasCommon/events/cursor-type.enum';

enum WorkDayColors {
	ACTIVE = '#2bab85',
	INACTIVE = '#ffffff',
}

export class TicketWorkDay extends TicketComponentHelper implements ComponentInterface {
	public override renderable = true;
	private buttonTexture: Texture;
	private shadedTexture: Texture;
	private _binder: EventBinder;
	private uniqueDay: number;

	constructor(
		buttonTexture: Texture,
		shadedTexture: Texture,
		canvasAngularLand: CanvasAngularLand,
		ticketContainer: TicketContainer,
		uniqueDay: number
	) {
		super(buttonTexture, canvasAngularLand, ticketContainer);
		this.buttonTexture = buttonTexture;
		this.shadedTexture = shadedTexture;
		this.uniqueDay = uniqueDay;

		this._binder = new EventBinder(this);

		this.eventMode = EventMode.Static;
		this.cursor = CursorType.Pointer;
		this.alpha = 1.0;

		this.setupInteraction();
	}

	private setupInteraction(): void {
		this._binder.add('hammer-singletap', (event) => {
			const parent = this.parent as TicketWorkDaysContainer;
			parent.toggleValue(this.uniqueDay);
		});
	}

	public setActive(): void {
		this.tint = convertHexStringToNumber(WorkDayColors.ACTIVE);
	}

	public setInactive(): void {
		this.tint = convertHexStringToNumber(WorkDayColors.INACTIVE);
	}

	public setShaded(): void {
		this.texture = this.shadedTexture;
		this.alpha = 0.33;
	}

	public setDefault(): void {
		this.texture = this.buttonTexture;
		this.alpha = 1.0;
	}

	public override destroy(options?) {
		this._binder.destroy();
		this.buttonTexture = null;
		this.shadedTexture = null;
		super.destroy(options);
	}
}
